import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';
import { VehicleTransport } from '@/new-transport/_models/transport.model';
import { computed } from '@angular/core';
import { calculateVehicleFreeSeats } from '@/new-transport/_utils/calculate-vehicle-free-seats/calculate-vehicle-free-seats';

export type VehicleState = {
	vehicles: VehicleTransport[];
};

export const vehicleInitialState: VehicleState = {
	vehicles: [],
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function withVehiclesSidenav() {
	return signalStoreFeature(
		withState(vehicleInitialState),
		withComputed(({ vehicles }) => ({
			shouldShowToggleAllVehiclesRoutes: computed(() => vehicles().some((vehicle) => !vehicle.visible)),
			vehicleInUse: computed(() => vehicles().find((vehicle) => vehicle.inUse)),
			vehicleInUseFreeSeats: computed(() => {
				const vehicleInUse = vehicles().find((vehicle) => vehicle.inUse);
				if (vehicleInUse) {
					return calculateVehicleFreeSeats(vehicleInUse.capacity, vehicleInUse.crew, vehicleInUse.takenSeats);
				}
				return 0;
			}),
		})),
		withMethods((store) => ({
			setVehicles(vehicles: VehicleTransport[]) {
				patchState(store, (state) => ({ ...state, vehicles }));
			},
			setAllVehiclesRoutesVisible() {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) => ({ ...v, visible: true })),
				}));
			},
			toggleVehicleRouteVisibility(vehicle: VehicleTransport) {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) => (v.id === vehicle.id ? { ...v, visible: !v.visible } : v)),
				}));
			},
			useVehicle(vehicle: VehicleTransport) {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) => ({ ...v, inUse: v.id === vehicle.id })),
				}));
			},
			unselectVehicle(vehicle: VehicleTransport) {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.filter((v) => v.id !== vehicle.id),
				}));
			},
			setVehicleFreeSeats($event: { vehicle: VehicleTransport; crew: number }) {
				const { vehicle, crew } = $event;

				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) => (v.id === vehicle.id ? { ...v, crew: crew } : v)),
				}));
			},
			getVehicle(id: number): VehicleTransport {
				return store.vehicles().find((v) => v.id === id);
			},
			setVehicleInUseTakenSeats(takenSeats: number) {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) => (v.inUse ? { ...v, takenSeats: takenSeats } : v)),
				}));
			},
			releaseVehicleInUseTakenSeats(seatsAmount: number) {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) =>
						v.inUse ? { ...v, takenSeats: v.takenSeats - seatsAmount } : v,
					),
				}));
			},
			releaseAllVehicleInUseTakenSeats() {
				patchState(store, (state) => ({
					...state,
					vehicles: state.vehicles.map((v) => (v.inUse ? { ...v, takenSeats: 0 } : v)),
				}));
			},
		})),
	);
}
